import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=e1353da8&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"
import style1 from "./setting.vue?vue&type=style&index=1&id=e1353da8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1353da8",
  null
  
)

export default component.exports